import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import DatePicker from "../../../../components/DatePicker";

const pad = (n) => String(n).padStart(2, "0");

const CalendarNavigation = ({
  currentDate,
  monthNames,
  styles,
  screenSize,
  language,
  theme,
  handlePrevMonth,
  handleNextMonth,
  handleButtonHover,
  onSelectMonth,
}) => {
  const isRTL = language === "ar";
  const monthValue = `${currentDate.getFullYear()}-${pad(currentDate.getMonth() + 1)}-${pad(
    currentDate.getDate()
  )}`;

  return (
    <div style={styles.calendarHeader}>
      <div style={styles.calendarNavigation}>
        <button
          style={styles.navButton}
          onClick={handlePrevMonth}
          onMouseEnter={(e) => handleButtonHover(e, true)}
          onMouseLeave={(e) => handleButtonHover(e, false)}
        >
          <ChevronLeft size={screenSize.isMobile ? 20 : 24} />
        </button>

        <div style={{ minWidth: screenSize.isMobile ? "160px" : "220px" }}>
          <DatePicker
            theme={theme}
            isRTL={isRTL}
            value={monthValue}
            onChange={(dateStr) => onSelectMonth?.(new Date(`${dateStr}T00:00:00`))}
            placeholder={`${monthNames[currentDate.getMonth()]} ${currentDate.getFullYear()}`}
          />
        </div>

        <button
          style={styles.navButton}
          onClick={handleNextMonth}
          onMouseEnter={(e) => handleButtonHover(e, true)}
          onMouseLeave={(e) => handleButtonHover(e, false)}
        >
          <ChevronRight size={screenSize.isMobile ? 20 : 24} />
        </button>
      </div>
    </div>
  );
};

export default CalendarNavigation;
